// extracted by mini-css-extract-plugin
module.exports = {"ionColorFacebook":"colors_ionColorFacebook__2sk0R","ion-color-gold":"colors_ion-color-gold__3GwL4"};